/** @format */

import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { useGeneralState } from "../state/useGeneralState";
import axiosInstance from "../lib/axios";

export const PaymentMethod = {
    PayWithCard: "Pay with Card",
    PayWithXCEL: "Pay with XCEL",
    PayWithBankApp: "Pay with Bank App",
    PayWithBankAccount: "Pay with Bank Account",
    PayWithMobileMoney: "Pay with Mobile Money",
    PayWithUSSD: "Pay with USSD",
    PayWithQRCode: "Pay with QR Code",
    PayWithApplePay: "Pay with Apple Pay",
};

export const PaymentOnlyMethod = {
    momo: "momo",
    card: "card",
    bank_app: "bank_app",
    bank_account: "bank_account",
    xcel: "xcel",
    qr_code: "qr_code",
    ussd: "ussd",
    apple_pay: "apple_pay",
};

export const PaymentMethodDescriptior = {};
PaymentMethodDescriptior[PaymentMethod.PayWithCard] = "Card";
PaymentMethodDescriptior[PaymentMethod.PayWithXCEL] = "Xcel";
PaymentMethodDescriptior[PaymentMethod.PayWithBankAccount] = "Bank";
PaymentMethodDescriptior[PaymentMethod.PayWithBankApp] = "Bank App";
PaymentMethodDescriptior[PaymentMethod.PayWithMobileMoney] = "Mobile Money";
PaymentMethodDescriptior[PaymentMethod.PayWithQRCode] = "QR-Code";
PaymentMethodDescriptior[PaymentMethod.PayWithApplePay] = "Apple Pay";

function PaymentMethods(props) {
    const merchantDetails = props?.merchantDetails ?? "";
    // const PaymentMethod = {
    //     PayWithXCEL:
    //         merchantDetails?.ent_type === "RELIGIOUS"
    //             ? "Give With XCEL"
    //             : "Pay with XCEL",
    //     PayWithCard:
    //         merchantDetails?.ent_type === "RELIGIOUS"
    //             ? "Give With Card"
    //             : "Pay with Card",
    //     PayWithBankApp:
    //         merchantDetails?.ent_type === "RELIGIOUS"
    //             ? "Give With Bank App"
    //             : "Pay with Bank App",
    //     PayWithBankAccount:
    //         merchantDetails?.ent_type === "RELIGIOUS"
    //             ? "Give With Bank Account"
    //             : "Pay with Bank Account",
    //     PayWithMobileMoney:
    //         merchantDetails?.ent_type === "RELIGIOUS"
    //             ? "Give With Mobile Money"
    //             : "Pay with Mobile Money",
    //     PayWithUSSD:
    //         merchantDetails?.ent_type === "RELIGIOUS"
    //             ? "Give With USSD"
    //             : "Pay with USSD",
    //     PayWithQRCode:
    //         merchantDetails?.ent_type === "RELIGIOUS"
    //             ? "Give With QR Code"
    //             : "Pay with QR Code",
    // };

    // const PaymentMethodDescriptior = {};
    // PaymentMethodDescriptior[PaymentMethod.PayWithXCEL] = "Xcel";
    // PaymentMethodDescriptior[PaymentMethod.PayWithCard] = "Card";
    // PaymentMethodDescriptior[PaymentMethod.PayWithBankAccount] = "Bank";
    // PaymentMethodDescriptior[PaymentMethod.PayWithBankApp] = "Bank App";
    // PaymentMethodDescriptior[PaymentMethod.PayWithMobileMoney] = "Mobile Money";
    // PaymentMethodDescriptior[PaymentMethod.PayWithQRCode] = "QR-Code";
    const { transactionBaseUrl, method } = useGeneralState();

    const onMethodSelected = (item) => {
        props.onMethodSelected(item.key);

        // if (item.key !== PaymentMethod?.PayWithMobileMoney) {
        //     fetchProductFees();
        // }
    };

    const fetchProductFees = async () => {
        props.setSelectedProduct(JSON.parse(props?.description));
        const products = JSON.parse(props?.description);
        const selectedProducts = [];
        let totalAmountToPay = 0;

        Object.keys(products).map((i) => {
            if (Number(products[i]?.amount) <= 0) {
                return;
            }

            selectedProducts.push({
                amount: Number(products[i]?.amount),
                product_id: i,
            });

            totalAmountToPay = totalAmountToPay + Number(products[i]?.amount);
        });

        let payload = {
            products: selectedProducts,
            payment_option: props.selectedMethod,
        };
        const result = await axiosInstance.post(
            `${transactionBaseUrl}merchant/charge-customer/${merchantDetails?.merchant_id}`,
            payload
        );

        if (result?.data?.data) {
            const productDetails = result.data.data?.productDetails;
            let fees = productDetails.reduce((acc, curr) => acc + curr.fee, 0);
            props.onFeesFetchSuccess(fees);
            props.onTotalAmountChange(result.data.data?.totalAmount);
            return result?.data?.data;
        } else {
            props.onTotalAmountChange(result.data.data?.totalAmount);
        }
    };

    const onlyAllowedPayment = props?.onlyAllowedPayment ?? "";

    const selectedMno = props?.selectedMno;

    const data = [
        {
            key: PaymentMethod.PayWithCard,
            title: "Card",
            value: PaymentOnlyMethod.card,
            icon: "./images/card.svg",
        },
        {
            key: PaymentMethod.PayWithXCEL,
            title: "XCEL",
            value: PaymentOnlyMethod.xcel,
            icon: "./images/option-logo.svg",
        },

        {
            key: PaymentMethod.PayWithBankApp,
            title: "Bank App",
            value: PaymentOnlyMethod.bank_app,
            icon: "./images/bank-app.svg",
        },
        {
            key: PaymentMethod.PayWithBankAccount,
            value: PaymentOnlyMethod.bank_account,
            title: "Bank Account",
            icon: "./images/bank-account.svg",
        },
        {
            key: PaymentMethod.PayWithMobileMoney,
            title: "Mobile Money",
            icon: "./images/momo.svg",
            value: PaymentOnlyMethod.momo,
        },
        {
            key: PaymentMethod.PayWithUSSD,
            title: "USSD Code",
            icon: "./images/ussd.svg",
            value: PaymentOnlyMethod.ussd,
        },
        {
            key: PaymentMethod.PayWithQRCode,
            title: "Pay with QR Code",
            icon: "./images/qr-code.svg",
            value: PaymentOnlyMethod.qr_code,
        },
        {
            key: PaymentMethod.PayWithApplePay,
            title: "Apple Pay",
            icon: "./images/card.svg",
            value: PaymentOnlyMethod.apple_pay,
        },
    ];

    let newData = data.filter((i) => {
        return (props?.selectedPaymentMethod ?? []).includes(i.key);
    });

    if (onlyAllowedPayment) {
        newData = newData.filter((i) => {
            return i.value === onlyAllowedPayment;
        });
    }

    const [hover, setHover] = useState();

    useEffect(() => {
        if (props?.selectedMethod) {
            if (props.selectedMethod !== PaymentMethod?.PayWithMobileMoney) {
                fetchProductFees();
            }
        }
        // } else {
        //     if (method !== PaymentMethod?.PayWithMobileMoney) {
        //         fetchProductFees();
        //     }
        // }
    }, [props?.selectedMethod, method]);

    return (
        <>
            <ul
                className={`flex flex-row md:flex-col flex-wrap w-auto md:w-[220px] ${
                    !isEmpty(onlyAllowedPayment) ? "hidden md:flex" : ""
                }`}>
                {newData.map((item) => {
                    const active = onlyAllowedPayment
                        ? item.value == onlyAllowedPayment
                        : item.key === method;

                    const hoverId = hover === item.key;

                    return (
                        <li
                            className={`method-card ${
                                active && "active"
                            } justify-between`}
                            key={item.key}
                            onMouseEnter={(e) => {
                                setHover(item.key);
                            }}
                            onMouseLeave={() => {
                                setHover(undefined);
                            }}
                            onClick={() => {
                                onMethodSelected(item);
                            }}>
                            <div className="flex flex-row gap-2 justify-center items-center">
                                <img
                                    src={`${item.icon}`}
                                    alt=""
                                    srcSet=""
                                    className={`rounded-full w-[40px] h-[40px] p-1 ${
                                        active ? "bg-white" : "bg-[#eee]"
                                    }`}
                                />
                                <div className="md:flex">{item.title}</div>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </>
    );
}

export default PaymentMethods;
